export default "__VITE_ASSET__Bp_tKgu6__$_?url__"